import { render } from "./RegisterClient.vue?vue&type=template&id=0a6d67bc"
import script from "./RegisterClient.vue?vue&type=script&lang=js"
export * from "./RegisterClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__